import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Field, reduxForm, initialize } from 'redux-form';
import { NavLink } from "react-router-dom";
import { SiteWrapper } from "../common";
import { Page, Card, Button, Form, Dimmer, Alert, Table } from "tabler-react";
import Multiselect from 'react-widgets/lib/Multiselect';
import { findUsers, getRole, createRole, updateRole, deleteRole, patchUsers } from '../actions';
import { roleSettings as settings } from './';
import { confirmAlert } from 'react-confirm-alert';
import Auth from '../auth/auth';

const auth = new Auth({});

class RoleFormPage extends Component {

  componentDidMount() {

    const { id } = this.props.match.params;
    if (id) {
      this.getRole(id);
      let alert = localStorage.getItem('createRole');
      if (alert) {
        alert = JSON.parse(alert);
        this.setState({ alert });
        localStorage.removeItem('createRole');
      }
    }

    if (!this.props.users.items)  {
      this.props.findUsers(1, 100000);
    }
  }

  constructor(props) {
    super(props);

    this.state = {
      role: {},
      getRoleLoader: false,
      submitLoader: false,
      deleteLoader: false,
      alert: {
        display: false,
        type: '',
        icon: '',
        message: ''
      },
      type: 'ERP',
      selected: [],
      modules: settings[0].modules,
      settings: settings
    };

    this.renderTextField = this.renderTextField.bind(this);
    this.renderAsterisk = this.renderAsterisk.bind(this);
    this.renderMultiselect = this.renderMultiselect.bind(this);
    this.renderActions = this.renderActions.bind(this);
    this.onChangeSystemType = this.onChangeSystemType.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.handleOnDelete = this.handleOnDelete.bind(this);

  }

  onSubmit(values) {
    console.log('onSubmit', values);
    const { id } = this.props.match.params;
    const { selected, type } = this.state;
    values.permissions = selected;
    if (!values.type) values.type = type;
    console.log('onSubmit_2', values);
    this.setState({ submitLoader: true });

    if (!id)
    {
      this.props.createRole(values, (response) => {
        console.log('createRole', response);
        this.setState({ submitLoader: false });
        localStorage.setItem('createRole', JSON.stringify({ display: true, icon: 'check', type: 'success', message: `Role successfully created.` }));
        this.props.history.push(`/roles/${response.data.id}`);
      }, (error) => {
        console.log('createRole', error);
        this.setState({ submitLoader: false, alert: { display: true, icon: 'alert-triangle', type: 'danger', message: 'Unable to create new role.' } });
      });
    }
    else
    {
      this.props.updateRole(values, (response) => {
        console.log('updateRole', response);

        // patch users
        let { data } = response;
        let userPatches = [];

        // users that are newly added to the role
        let newUsers = values.users.filter(f => !data.users.find(u => u.id === f.id));
        console.log('newUsers', newUsers);

        let removedUsers = data.users.filter(f => !values.users.find(u => u.id === f.id));
        console.log('removedUsers', removedUsers);

        let remainingUsers = data.users.filter(f => values.users.find(u => u.id === f.id));
        console.log('remainingUsers', remainingUsers);

        for (let u of newUsers) {
          let roles = u.roles.map(r => r.id);
          u.roles.push(data.id);
          u.patchData = [{
            op: "replace",
            path: "/roles",
            value: roles
          }];
          userPatches.push(u);
        }

        for (let u of removedUsers) {
          let roles = u.roles.map(r => r.id);
          roles = roles.filter(f => f !== data.id);
          u.patchData = [{
            op: "replace",
            path: "/roles",
            value: roles
          }];
          userPatches.push(u);
        }

        for (let u of remainingUsers) {
          let roles = u.roles.map(r => r.id);
          u.patchData = [{
            op: "replace",
            path: "/roles",
            value: roles
          }];
          userPatches.push(u);
        }

        this.props.patchUsers(userPatches, (response) => {
          console.log('patchUsers', response);
          this.setState({ submitLoader: false, alert: { display: true, icon: 'check', type: 'success', message: `Role successfully updated.` }});
        }, (error) => {
          console.log('patchUsers', error);
        });

      }, (error) => {
        console.log('updateRole', error);
        this.setState({ submitLoader: false, alert: { display: true, icon: 'alert-triangle', type: 'danger', message: 'Unable to update role.' } });
      });
    }

  }

  handleOnDelete() {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <Card>
            <Card.Body>
              <h3>Are you sure?</h3>
              <p>You want to delete this role?</p>
              <Button.List>
                <Button type="button" color="secondary" onClick={onClose}>No</Button>
                <Button type="button" color="danger" onClick={() => {
                    this.onDelete();
                    onClose();
                }}>Yes</Button>
              </Button.List>
            </Card.Body>
          </Card>
        )
      }
    });
  }

  onDelete() {
    const { id } = this.props.match.params;
    this.setState({ deleteLoader: true });
    this.props.deleteRole(id, (response) => {
      console.log('deleteRole', response);
      localStorage.setItem('deleteRole', JSON.stringify({ display: true, icon: 'check', type: 'success', message: `Role successfully deleted.` }));
      this.props.history.push(`/roles`);
    }, (error) => {
      console.log('deleteRole', error);
      this.setState({ deleteLoader: false, alert: { display: true, icon: 'alert-triangle', type: 'danger', message: 'Unable to delete role.' } });
    });
  }

  onChangeSystemType(event) {
    console.log('onChangeSystemType', event.target.value);
    let type = event.target.value;
    let modules = settings.find(s => s.type === type).modules;

    this.setState({
      selected: [],
      type,
      modules
    });
  }

  onCheckPermission(module, action, event) {
    console.log('onCheckPermission', module, action, event.target.checked);
    let { selected } = this.state;

    var permission = selected.find(s => s.module === module && s.action === action);

    // check if checked and duplicate permissions exist
    if (event.target.checked && permission != null) return;

    // check if not checked and need to remove
    if (!event.target.checked && permission == null) return;

    if (event.target.checked)
      selected.push({ module, action });
    else {
      selected = selected.filter(s => s !== permission);
    }
    console.log('onCheckPermission_2', selected);
    this.setState({ selected });
  }

  populateUsers() {
    if (!this.props.users.items) return [];
    let { items } = this.props.users;
    items.forEach(i => {
      i.name = i.userName;
    });
    return items;
  }

  getRole(id) {
    this.setState({ getRoleLoader: true });
    this.props.getRole(id, (response) => {
      console.log('getRole', response);
      this.props.initialize('RoleForm', response.data);
      let modules = settings.find(s => s.type === response.data.type).modules;
      this.setState({
        getRoleLoader: false,
        role: response.data,
        selected: response.data.permissions,
        type: response.data.type,
        modules
       });
    });
  }

  renderAsterisk(isRequired) {
    let asterisk ;
    if (isRequired) asterisk =  <span className="text-danger">*</span>;
    return asterisk;
  }

  renderTextField(field) {
    const { meta: { touched, error }, label, input, isRequired, type, value } = field;
    return (
       <Form.Group>
         {label &&
           <Form.Label>{label} {this.renderAsterisk(isRequired)}</Form.Label>
         }
         <Form.Input
           value={value ? value : ''}
           type={type ? type : 'text'}
           feedback={error}
           invalid={touched && error ? 'invalid' : undefined}
           {...input}
          />
       </Form.Group>
    );
  }

  renderMultiselect({ input, data, valueField, textField, isRequired, label }) {
    return (
      <Form.Group>
          <Form.Label>{label} {this.renderAsterisk(isRequired)}</Form.Label>
          <Multiselect
            {...input}
            onBlur={() => input.onBlur()}
            value={input.value || []} // requires value to be an array
            data={data}
            valueField={valueField}
            textField={textField}
          />
      </Form.Group>
    );
  }

  renderAlert() {
    return (
      <div>
        {this.state.alert.display &&
          <Alert type={this.state.alert.type} icon={this.state.alert.icon} isDismissible>
            {this.state.alert.message}
          </Alert>
        }
      </div>
    );
  }

  renderModules(module) {
    return (
      <Table.Row key={module.key}>
        <Table.Col>{module.name}</Table.Col>
        <Table.Col>
          {module.actions.map((p) => this.renderActions(module.key, p))}
        </Table.Col>
      </Table.Row>
    );
  }

  renderActions(key, action) {
    const checked = this.state.selected.find(s => s.module === key && s.action === action) != null;
    return (
      <Form.Checkbox checked={checked} isInline label={action} onChange={(event) => this.onCheckPermission(key, action, event)} key={`${key}.${action}`} name={`${key}.${action}`} value={action} />
    );
  }

  render() {

    const { handleSubmit } = this.props;
    const { id } = this.props.match.params;

    return(
      <SiteWrapper>
          <Page.Content>
            {this.renderAlert()}
            <Form onSubmit={handleSubmit(this.onSubmit.bind(this))}>
              <Card>
                <Card.Header>
                  <Card.Title>
                     {!id ? 'New' : 'Update'} Role
                  </Card.Title>
                </Card.Header>
                <Card.Body>
                  <Dimmer active={this.state.getRoleLoader} loader>
                      <div className="row">
                          <div className="col-md-4">
                            <Field label="Name" name="name" isRequired="true" component={this.renderTextField} />
                            <Form.Group>
                              <Form.Label>System <span className="text-danger">*</span></Form.Label>
                              <Field name="type" className="form-control" component="select" onChange={this.onChangeSystemType}>
                                 <option value="ERP">ERP</option>
                                 <option value="IMS">IMS</option>
                                 <option value="OPS">OPS</option>
                                 <option value="ESYS">ESYS</option>
                                 <option value="SIGN">SIGN</option>
                                 <option value="PAYROLL">PAYROLL</option>
                                 <option value="TMS">TMS</option>
                                 <option value="TS">TS</option>
                                 <option value="DORM">DORM</option>
                                 <option value="FARM">FARM</option>
                              </Field>
                            </Form.Group>
                            {id &&
                              <Field label="Users" name="users" component={this.renderMultiselect} valueField="id" textField="name" data={this.populateUsers()} />
                            }
                          </div>
                          <div className="col-md-8">
                            <Table className="table-sm" striped>
                              <Table.Header>
                                <Table.Row>
                                  <Table.ColHeader>Modules</Table.ColHeader>
                                  <Table.ColHeader>Permissions</Table.ColHeader>
                                </Table.Row>
                              </Table.Header>
                              <Table.Body>
                                  {this.state.modules.map((p) => this.renderModules(p))}
                              </Table.Body>
                              </Table>
                          </div>
                      </div>
                 </Dimmer>
                </Card.Body>
                <Card.Footer>
                  <div className="d-flex">
                    <NavLink to="/roles">
                      <Button color="secondary">Back</Button>
                    </NavLink>
                    {(id && auth.hasAccess('role', 'delete')) &&
                      <Button loading={this.state.deleteLoader} onClick={this.handleOnDelete} className="ml-auto" color="danger" type="button">Delete</Button>
                    }
                    {(!id || auth.hasAccess('role', 'update')) &&
                      <Button loading={this.state.submitLoader} color="success" className={id && auth.hasAccess('role', 'delete') ? 'ml-2' : 'ml-auto'}>Submit</Button>
                    }
                  </div>
                </Card.Footer>
              </Card>
             </Form>
          </Page.Content>
      </SiteWrapper>
    );
  }
}


function validate(values) {
  const errors = {};

  if (!values.name)  {
    errors.name = 'Required Field';
  }

  return errors;
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
      findUsers, getRole, createRole, initialize, updateRole, deleteRole, patchUsers
  }, dispatch);
}

function mapStateToProps({ users }) {
  return { users };
}

export default reduxForm({
  validate,
  form: 'RoleForm'
})(connect(mapStateToProps, mapDispatchToProps)(RoleFormPage))



// WEBPACK FOOTER //
// ./src/role/role-form.react.js